export const getCheckoutSessionIDMutation = async ({ client }) => {
  const { data } = await client.post(`/payments/session_id`);
  return data;
};

export const setSuccessSessionMutation = async ({ client, sessionId }) => {
  const { data } = await client.post(`/payments/success`, {
    session_id: sessionId,
  });
  return data;
};
